<template lang="pug">
.custom_dialog
  .dialog_container.d-flex.flex-column
    img(src="@/assets/img/icons/alert.svg")
    .dialog_content.mt-3
      h2.dialog_title {{ title }}
      p {{ content }}
</template>

<script>
export default {
  name: "DialogAlert",
  props: {
    title: String,
    content: String,
  },
  methods: {
    toMemberCenter() {
      this.$router.push({ name: "MemberCenter" });
      this.closeClick();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/dialog/dialog";
.custom_dialog {
  .dialog_container {
    min-width: 355px;
    width: 355px;
  }
}

// RWD > extra small
@media (max-width: 575px) {
  .custom_dialog {
    .dialog_container {
      min-width: 0;
      width: 100%;

      img {
        width: 50px;
        height: 50px;
        margin: auto;
      }
    }
  }
}
</style>
